import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { SearchableListComponent } from '../../components/searchable-list/searchable-list.component';
import { FormModule } from '../forms/forms.module';

@NgModule({
  declarations: [SearchableListComponent],
  imports: [CommonModule, FormModule],
  exports: [NgxDatatableModule, SearchableListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
